import { fork, all } from 'redux-saga/effects';

import * as clients from './clients';

export default function* rootSaga() {
  yield all([...Object.values(clients)].map(fork));
}
